import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import ImageHandler from '../../utils/ImageHandler';
import Video from '../../utils/Vimeo';

/*
import Image from '../Image';
import Video from '../Video';
*/

// ====================================
// Carousel
// ================

const Carousel = (props) => {
  const { video, images } = props;
  const [activeIndex, setActiveIndex] = useState(0);
  const [paused, setPaused] = useState(false);
  const [media, setMedia] = useState(images);

  if (!images) return null;

  useEffect(() => {
    if (video.vimeo_raw !== '') {
      setMedia([
        {
          source: video.vimeo_oembed.response.thumbnail_url_with_play_button,
          video: true,
        },
        ...media,
      ]);
    }
  }, []);

  const setSlide = (index) => {
    setActiveIndex(index);
    setPaused(true);
  };

  return (
    <article>
      <div className="brand-carousel-hero brand-background-grey-lighter">
        {video.vimeo_raw !== '' && (
          <div
            data-id="0"
            className={`brand-carousel-embed ${
              activeIndex === 0 ? 'd-block' : 'd-none'
            }`}
          >
            <Video source={video} autoPlay isPaused={paused} />
          </div>
        )}
        {images &&
          images.map((item, index) => {
            let idx = index;
            if (video.vimeo_raw !== '') idx += 1;
            return (
              <div
                data-id={idx}
                className={`brand-carousel-embed brand-background-cover ${
                  activeIndex === idx ? 'd-block' : 'd-none'
                }`}
                style={{
                  backgroundImage: `url(${ImageHandler(
                    item.source,
                    '1920x1080',
                  )})`,
                }}
              />
            );
          })}
      </div>
      <div className="p-2 p-md-4 brand-background-white">
        <div className="brand-slider">
          <ul className="brand-slider-container list-inline">
            {media.map((item, index) => {
              return (
                <li
                  data-id={index}
                  onClick={() => setSlide(index)}
                  className={`list-inline-item brand-slider-thumbnail mr-2 mr-md-4${
                    activeIndex === index
                      ? ' brand-slider-thumbnail-active'
                      : ''
                  }`}
                >
                  {item.video ? (
                    <img
                      src={item.source}
                      alt="Video"
                      className="brand-slider-thumbnail-image"
                    />
                  ) : (
                    <img
                      src={item.source}
                      alt="Thumbnail"
                      className="brand-slider-thumbnail-image"
                    />
                  )}
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </article>
  );
};

export default Carousel;

// ====================================
// PropTypes
// ================

Carousel.propTypes = {
  images: PropTypes.objectOf({
    thumbnail: PropTypes.objectOf(PropTypes.string),
  }).isRequired,
  video: PropTypes.objectOf({
    url: PropTypes.string,
    alt: PropTypes.string,
    dimensions: PropTypes.objectOf({
      width: PropTypes.number,
      height: PropTypes.number,
    }),
  }),
};

Carousel.defaultProps = {
  video: null,
};
